/**
 * Número do WhatsApp para leads que completam o diagnóstico na landing.
 * Usado no LeadDiagnosticModal (mensagem personalizada com nome, concessionária e gargalo).
 */
export const WHATSAPP_CONSULTOR_DIAGNOSTIC = "5512991026488";

/**
 * Número do WhatsApp para contato geral (ex.: CTA quando o modal de diagnóstico não é usado).
 */
export const WHATSAPP_CONSULTOR_GENERAL = "5511999999999";

/**
 * Domínio usado para e-mail placeholder quando o cliente não informa e-mail (ex.: em reserva/cadastro de veículo).
 * Pode ser sobrescrito por NEXT_PUBLIC_PLACEHOLDER_EMAIL_DOMAIN.
 */
export const PLACEHOLDER_EMAIL_DOMAIN =
  typeof process !== "undefined" && process.env.NEXT_PUBLIC_PLACEHOLDER_EMAIL_DOMAIN
    ? process.env.NEXT_PUBLIC_PLACEHOLDER_EMAIL_DOMAIN
    : "placeholder.local";

/**
 * Caminho da logo do sistema (UI). Favicon: copiar `logo-azul.png` para `src/app/icon.png`, `src/app/apple-icon.png` e `public/favicon.png`.
 */
export const APP_LOGO_PATH = "/assets/logo.png";
